<main
  class="flex min-h-screen items-center justify-center bg-primary-bg px-6 py-12"
  role="alert"
  aria-live="assertive"
>
  <div
    class="max-w-lg rounded-md border border-warning bg-warning-50 p-6 text-primary-text shadow-sm"
  >
    <h1 class="text-lg font-semibold">This session was replaced</h1>
    <p class="mt-3 text-sm leading-relaxed">
      Another participant account was opened in this browser, so this tab can no longer show the
      previous account. Close this tab or open the participant again from Mission Control.
    </p>
  </div>
</main>
